module.exports = __webpack_public_path__ + "static/img/49-2.5cc04e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/49-2.jpg
// module id = 1Iih
// module chunks = 0